import React from 'react';

// import styled from 'styled-components';
import { inject } from 'mobx-react';

import getContentComponent from './getContentComponent';

import Footer from '../components/shared/Footer';

// const Wrapper = styled.div `
//     overflow: auto;
// `;

const mapper = (stores, props) => ({
    intl: stores.intl.dictionary,
    content: stores.core.content,
});

class Content extends React.Component {
    
    refs = {};

    render() {
        return (
            <>
                {[...this._generateContent()]}
                <Footer />
            </>
        );
    }

    *_generateContent() {
        let { content } = this.props;

        content = content || [];

        for (const [i, entry] of content.entries()) {
            yield this._renderContent(`${entry.ref}-${i}`, entry);
        }

    }

    _renderContent(key, content) {
        const { intl } = this.props;
        // Keep references to named entries
        let ref = this.refs[content.ref];
        if (!ref && content.ref) {
            ref = React.createRef();
            this.refs = Object.assign({}, this.refs, { [content.ref]: ref });
        }

        // Render the content component
        const Content = getContentComponent(content);

        return (
            <Content
                key={key}
                ref={ref}
                style={content.style}>
                {intl[content.dictionary]}
            </Content>
        );
    }
    
}

export default inject(mapper)(Content);
